import React, { useState, useEffect } from 'react';
import API from '@utils/api';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { connect, useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { stringify } from 'query-string';
import { isEmpty } from 'lodash';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { Layout, Container, CheckboxInput, ProductTile, ProductTileCustom } from '@components';
import { useSelectedRetailerSelector } from '@stores/locations/selectors';
import { reqSaveMyDealerAction } from '@stores/locations/actions';
import { getLanguageId } from '@/helpers/language';
import { translatePrice, completeSellPrice } from '@helpers/product';

import { formatPostData } from '@/services/postService';
import { PageContext } from '@contexts';
import { checkValue, checkEnabled } from '@components/OptionalFeature';
import { apiClient, crmClient } from '@/http-client';
import styles from './ContactADealer.module.scss';


const phoneRegExp = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const postalRegExp = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

const formSchema = Yup.object().shape({
  firstname: Yup.string().required('Please enter your first name'),
  lastname: Yup.string().required('Please enter your last name'),
  email: Yup.string().matches(emailRegExp, 'Invalid email address').required('Please enter your email'),
  // city: Yup.string().required('Please enter your city'),
  postalCode: Yup.string().matches(postalRegExp, 'Invalid Postal Code').required('Please enter your postal code'),
  phone: Yup.string().matches(phoneRegExp, 'Invalid phone number'),
  comments: Yup.string().required('Please enter your comments')
});

function ContactDealer(props) {
  const router = useRouter();
  const {
    route,
    locale,
    query: { dealer, product, isUsed }
  } = router;

  const dispatch = useDispatch();
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSavedDealer, setIsSavedDealer] = useState(false);
  const myDealer = useSelector(useSelectedRetailerSelector);

  const dealerInfo = props?.data?.dealerInfo ? props?.data?.dealerInfo : myDealer;
  const dealerName = isEmpty(dealerInfo) ? '' : dealerInfo?.name || dealerInfo?.dealerName;

  const subject = props?.data?.subject;
  const languageId = getLanguageId(locale);

  const productDetails = props?.data?.productDetails;

  useEffect(() => {
    if (!dealerInfo) {
      const uri = product ? `/dealer/select-a-dealer?product=${product}` : '/dealer/select-a-dealer';
      router.push(uri);
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      firstname: '',
      lastname: '',
      email: '',
      city: '',
      subject: subject ? subject : `${locale == 'fr' ? 'Contacter le concessionnaire' : 'Contact a Dealer'}`,
      language: '',
      stateorprovince: '',
      address: '',
      postalCode: '',
      optin: false,
      phone: '',
      comments: ''
    },
    validationSchema: formSchema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      var dealerOverride = values?.firstname.toString() == 'NAT020'? 'NAT020' : dealerInfo?.dealerCode?.toString();
      
      const data = 
        [
          {
            type: 'FieldValue',
            id: '220',
            name: 'email',
            value: values?.email?.toString()
          },
          {
            type: 'FieldValue',
            name: 'fname',
            id: '221',
            value: values?.firstname?.toString()
          },
          {
            type: 'FieldValue',
            name: 'lname',
            id: '222',
            value: values?.lastname?.toString()
          },
          {
            type: 'FieldValue',
            name: 'phone',
            id: '223',
            value: values?.phone?.toString()
          },
          /*
          {
            type: 'FieldValue',
            name: 'Address1',
            id: '224',
            value: values?.address?.toString()
          },*/
          {
            type: 'FieldValue',
            name: 'city',
            id: '225',
            value: values?.city?.toString()
          },
          {
            type: 'FieldValue',
            name: 'postal',
            id: '226',
            value: values?.postalCode?.toString()
          } /*
          {
            type: 'FieldValue',
            name: 'province',
            id: '227',
            value: values?.stateorprovince?.toString()
          },*/,
          {
            type: 'FieldValue',
            name: 'Comments',
            id: '292',
            value: values?.comments?.toString()
          },
          {
            type: 'FieldValue',
            name: 'dealercode',
            id: '258',
            value: dealerOverride
            //value: 'NAT020'
          },
          {
            type: 'FieldValue',
            name: 'leadSource',
            id: '262',
            value: 'kubota'
          },
          {
            type: 'FieldValue',
            name: 'department',
            id: '293',
            value: 'sales'
          },
          /*
          {
            type: 'FieldValue',
            name: 'Interested Year',
            id: '323',
            value: ''
          },
          {
            type: 'FieldValue',
            name: 'Interested Stock',
            id: '324',
            value: ''
          },
          {
            type: 'FieldValue',
            name: 'InterestedModel',
            id: '325',
            value: props?.interestedModel
          },
          {
            type: 'FieldValue',
            name: 'Interested Make',
            id: '326',
            value: props?.interestedMake
          },
          {
            type: 'FieldValue',
            name: 'Interested Condition',
            id: '327',
            value: props?.interestedCondition ? 'New' : 'Used'
          },*/
          {
            type: 'FieldValue',
            name: 'language',
            id: '236',
            value: locale?.toString()
          },
          {
            type: 'FieldValue',
            name: 'subject',
            id: '294',
            value: values?.subject?.toString()
          },
          {
            type: 'FieldValue',
            name: 'optin',
            id: '228',
            value: values?.optin?.toString()
          },
          {
            type: 'FieldValue',
            name: 'CLIENT_ID',
            id: '731',
            value: '36'
          },
          {
            type: 'FieldValue',
            name: 'CLIENT_NM',
            id: '732',
            value: 'Kubota'
          },
          {
            type: 'FieldValue',
            name: 'PROCESS_NM',
            id: '733',
            value: 'Lead Routing'
          },
          {
            type: 'FieldValue',
            name: 'INSERT_DT',
            id: '734',
            value: '1999-12-31'
          }
        ];

      setIsSubmit(true);
      API.post('/api/contactForm', data).then(
        (res) => {
          setIsSubmit(false);
          if (res?.response === 'success') {
            localStorage.setItem('formData', JSON.stringify(values));
            router.push(`/contact-success?dealer=${(dealerInfo?.dealerURLName || dealerInfo?.handle || '').toString()}`);
          }
        },
        () => {
          setIsSubmit(false);
        }
      );
    }
  });

  const renderMappedProductDetails = () => {
    if (isEmpty(productDetails)) {
      return null;
    }

    let label;

    if (isUsed === 'true') {
      if (productDetails.Tags?.some((tag) => tag.TagCode === 'Promotion' || tag.TagCode === 'Promotions')) {
        label = productDetails.Tags?.filter((tag) => tag.TagCode === 'Promotion' || tag.TagCode === 'Promotions').map((x) => x.TagDesc);
      }

      if (productDetails?.isCertified) label = 'Certified Used';

      const imageUrl = `/api/static/resource/images/usedmachinery/${productDetails.folderId}/full/${productDetails.image}`;

      return (
        <ProductTileCustom
          className={styles.Item}
          title={[productDetails.year, productDetails.make, productDetails.model].join(' ')}
          price={productDetails.price}
          features={productDetails.QuickFeatures}
          productCode={productDetails.ProductCode}
          productId={productDetails.ProductId}
          label={label}
          image={imageUrl}
          usedID={productDetails.usedID}
          category={productDetails.categoryId.toString()}
          comments={productDetails.comments}
          compareCheckboxShow={false}
          itemTitle={productDetails.model}
          power={productDetails.power}
          hours={productDetails.hours}
          dealer={productDetails.company}
        />
      );
    } else {
      if (productDetails.Tags?.some((tag) => tag.TagCode === 'Promotion' || tag.TagCode === 'Promotions')) {
        label = productDetails.Tags?.filter((tag) => tag.TagCode === 'Promotion' || tag.TagCode === 'Promotions').map((x) => x.TagDesc);
      }
      let sellPrice = completeSellPrice(productDetails.SellPrice, productDetails.LabourRate, productDetails.LabourHours, productDetails.PDIHours, productDetails.AdminFees);

      let bghero = false;
      if(productDetails.ProductType==5) bghero = true;
      return (
        <div className={styles.productEnquiry}>
          <p className="bold product-title">{locale == 'fr' ? 'Demande de produit': 'Product Inquiry'}</p>
          <ProductTile
            className={styles.Item}
            title={productDetails.ProductText[languageId]?.Title}
            subTitle={productDetails.ProductText[languageId]?.SubTitle}
            price={productDetails.MSRP}
            features={productDetails.QuickFeatures}
            productCode={productDetails.ProductCode}
            productId={productDetails.Id}
            hasStudio={!bghero}
            hasbgHero={bghero}
            featureTextEnabled={true}
            featureTitleEnabled={true}
            label={label}
            route={route}
            imageAltEnabled={true}
          />
        </div>
      );
    }
  };

  const toggleMyDealer = () => {
    setIsSavedDealer(!isSavedDealer);
    dispatch(reqSaveMyDealerAction({ location: isSavedDealer ? null : dealerInfo }));
  };

  //finding Form Element in data to use translation
  const formElementsData = props.data?.DisplayOptions?.find((item) => item.Name === 'FormElements')?.DisplayOptions;

  //hero
  const heroData = props.data?.DisplayOptions?.find((item) => item.Name === 'Hero')?.DisplayOptions;

  //subject of page
  const pageSubjectEnabled = checkEnabled(heroData, 'Subject');

  //Body
  const bodyData = props.data?.DisplayOptions?.find((item) => item.Name === 'Body')?.DisplayOptions;

  //ChangeDealer
  const ChangeDealerEnabled = checkEnabled(bodyData, 'ChangeDealer');

  //ChangeDealerText
  const ChangeDealerText = checkValue(bodyData, 'ChangeDealerText', locale);

  //show body component
  const bodyEnabled = checkEnabled(bodyData, 'DisplayComponent');

  //DealerName Enabled
  const DealerNameEnabled = true;

  //subject of page
  const pageSubject = checkValue(heroData, 'Subject', locale);

  //FirstName label
  const firstNameLabel = checkValue(formElementsData, 'FirstName', locale);

  //FirstName Error
  const firstNameError = checkValue(formElementsData, 'FirstNameMissingText', locale);

  //LastName label
  const lastNameLabel = checkValue(formElementsData, 'LastName', locale);

  //LastName Error
  const lastNameError = checkValue(formElementsData, 'LastNameMissingText', locale);

  //Email label
  const emailLabel = checkValue(formElementsData, 'EmailAddress', locale);

  //Email Error
  const emailError = checkValue(formElementsData, 'EmailAddressFormatErrorText', locale);

  //City label
  const cityLabel = checkValue(formElementsData, 'City', locale);

  //City Error
  const cityError = checkValue(formElementsData, 'CityMissingText', locale);

  //BusinessPhone label
  const phoneLabel = checkValue(formElementsData, 'BusinessPhone', locale);

  //BusinessPhone Error
  const phoneError = checkValue(formElementsData, 'BusinessPhoneMissingText', locale);

  //ButtonText label
  const buttonLabel = checkValue(formElementsData, 'ButtonText', locale);

  //Comments label
  const commentsLabel = checkValue(formElementsData, 'Comments', locale);

  //Comments error
  const commentError = checkValue(formElementsData, 'CommentsMissingText', locale);

  //console.log(formElementsData);
  //EmailOptInText
  const emailOptInText = checkValue(formElementsData, 'EmailOptInText', locale);

  //GeneralFormErrorText
  const generalFormErrorText = checkValue(formElementsData, 'GeneralFormErrorText', locale);

  //SaveAsDealer
  const saveAsDealer = checkValue(formElementsData, 'SaveAsDealer', locale);

  //Subject
  const subjectLabel = checkValue(formElementsData, 'Subject', locale);

  //PostalCode
  const postalCodeLabel = checkValue(formElementsData, 'ZipOrPostalCode', locale);

  //PostalCode error
  const postalCodeError = checkValue(formElementsData, 'ZipOrPostalCodeMissingText', locale);

  const flow = 'contact';

  return (
    <PageContext.Provider value={props?.data}>
      <Layout>
        <Container>
          <section className={styles.contactDealer}>
            <div className={styles.con}>
              <div className={styles.titleCon}>
                {/* <h1 className={styles.bigTitle}>{locale == 'fr' ? 'Contacter le concessionnaire' : 'Contact a Dealer'}</h1> */}
                {pageSubjectEnabled && <h1 className={styles.bigTitle}>{pageSubject}</h1>}
              </div>
              <div className={styles.infoCon}>
                {bodyEnabled && (
                  <>
                    <div className={styles.infoStep}>
                      <h3>
                        {locale == 'fr' ? 'Étape 1' : 'Step 1'}
                        <div className={styles.correctSvg}>
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10.9057" cy="11.0268" r="10.7768" fill="#11BE4C"></circle>
                            <path d="M6.23057 11.6096L9.37161 14.7705L16.2181 7.65039" stroke="white" strokeWidth="2"></path>
                          </svg>
                        </div>
                      </h3>
                      {DealerNameEnabled && (
                        <>
                        <h3>
                          {locale == 'fr' ? 'concessionnaire' : 'Dealer'}: {dealerName}
                        </h3>
                        <p>{dealerInfo?.address1}<br/>{dealerInfo?.city}, {dealerInfo?.province}<br/><span><a  className={styles.link}href={`tel:${dealerInfo?.phone}`}>{dealerInfo?.phone}</a></span></p>
                        </>

                      )}
                      <Link
                        href={`/find-a-dealer${isEmpty({ product, isUsed }) ? '?' + stringify({flow}) : '?' + stringify({ flow,product, isUsed })}`}
                        prefetch={false}
                      >
                        <a className={styles['button'] + ' ' + styles['breadcrumbLink']}>
                          {ChangeDealerEnabled ? ChangeDealerText :'Change dealer'}
                          {/* {locale == 'fr' ? 'Changer le concessionnaire' : 'Change Dealer'} */}
                        </a>
                      </Link>
                    </div>
                    <div className={styles.infoStep}>
                      <h3>{locale == 'fr' ? 'Étape 2' : 'Step 2'}</h3>
                      <h3>{formik.values.subject}</h3>
                      <p>{locale == 'fr' ? 'Information personnelle' : 'Personal Information'}</p>
                    </div>
                  </>
                )}

                <div className={styles.showMobile}>
                  {renderMappedProductDetails()}
                </div>

                <div className={styles.infoStep}>
                  <form className={styles.contactDealerForm} onSubmit={formik.handleSubmit}>
                    <div className={styles.formRow}>
                      <label>{firstNameLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${firstNameLabel}` : `Enter ${firstNameLabel}`}
                        type="text"
                        onChange={formik.handleChange}
                        id="firstname"
                        name="firstname"
                        value={formik.values.firstname}
                        required="true"
                      />
                      {formik.errors?.firstname && <div className={styles.formError}>{firstNameError}</div>}
                    </div>
                    <div className={styles.formRow}>
                      <label>{lastNameLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${lastNameLabel}` : `Enter ${lastNameLabel}`}
                        type="text"
                        onChange={formik.handleChange}
                        id="lastname"
                        name="lastname"
                        value={formik.values.lastname}
                        required="true"
                      />
                      {formik.errors?.lastname && <div className={styles.formError}>{lastNameError}</div>}
                    </div>
                    <div hidden className={styles.formRow}>
                      <label>{subjectLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${subjectLabel}` : `Enter ${subjectLabel}`}
                        type="subject"
                        onChange={formik.handleChange}
                        id="subject"
                        name="subject"
                        value={formik.values.subject}
                        disabled
                      />
                      {formik.errors?.subject && <div className={styles.formError}>{formik.errors?.subject}</div>}
                    </div>
                    <div className={styles.formRow}>
                      <label>{emailLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${emailLabel}` : `Enter ${emailLabel}`}
                        type="email"
                        onChange={formik.handleChange}
                        id="email"
                        name="email"
                        value={formik.values.email}
                        required="true"
                      />
                      {formik.errors?.email && <div className={styles.formError}>{emailError}</div>}
                    </div>

                    {/* <div className={styles.formRow}>
                      <label>State or Province (Optional)</label>
                      <input
                        placeholder="Enter State or Province"
                        type="text"
                        onChange={formik.handleChange}
                        id="stateorprovince"
                        name="stateorprovince"
                        value={formik.values.stateorprovince}
                      />
                      {formik.errors?.stateorprovince && <div className={styles.formError}>{formik.errors?.stateorprovince}</div>}
                    </div>*/}
                    <div className={styles.formRow}>
                      <label>{postalCodeLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${postalCodeLabel}` : `Enter ${postalCodeLabel}`}
                        type="text"
                        onChange={formik.handleChange}
                        id="postalCode"
                        name="postalCode"
                        value={formik.values.postalCode}
                      />
                      {formik.errors?.postalCode && <div className={styles.formError}>{postalCodeError}</div>}
                    </div>
                    <div className={styles.formRow}>
                      <label>{cityLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${cityLabel}` : `Enter ${cityLabel}`}
                        type="text"
                        onChange={formik.handleChange}
                        id="city"
                        name="city"
                        value={formik.values.city}
                      />
                      {formik.errors?.city && <div className={styles.formError}>{cityError}</div>}
                    </div>
                    <div className={styles.formRow}>
                      <label className="optional">{phoneLabel}</label>
                      <input
                        placeholder={locale == 'fr' ? `Entrez ${phoneLabel}` : `Enter ${phoneLabel}`}
                        type="text"
                        onChange={formik.handleChange}
                        id="phone"
                        name="phone"
                        value={formik.values.phone}
                      />
                      {formik.errors?.phone && <div className={styles.formError}>{phoneError}</div>}
                    </div>
                    {/*<div className={styles.formRow}>
                      <label className="optional">Address (Optional)</label>
                      <input
                        placeholder="Enter Address"
                        type="text"
                        onChange={formik.handleChange}
                        id="address"
                        name="address"
                        value={formik.values.address}
                       />
                    </div>*/}
                    <div className={styles.formRow}>
                      <label className="optional">{commentsLabel}</label>
                      <textarea
                        placeholder={locale == 'fr' ? `Entrez ${commentsLabel}` : `Enter ${commentsLabel}`}
                        type="text"
                        onChange={formik.handleChange}
                        id="comments"
                        name="comments"
                        value={formik.values.comments}
                        rows="6"
                        required="true"
                      ></textarea>
                      {formik.errors?.comments && <div className={styles.formError}>{commentError}</div>}
                    </div>
                    <div className={`${styles.formRow}`}>
                      <div className={styles.selectBox}>
                        <CheckboxInput
                          title={saveAsDealer}
                          className={styles.Compare}
                          onChange={toggleMyDealer}
                          name="save_as_dealer"
                          value={isSavedDealer}
                          id={'save_as_dealer'}
                          checked={isSavedDealer}
                        />
                      </div>
                      {formik.errors?.optin && <div className={styles.formError}>{formik.errors?.optin}</div>}
                    </div>
                    <div className={`${styles.formRow} ${styles.terms}`}>
                      <div className={styles.selectBox}>
                        <CheckboxInput
                          title={emailOptInText}
                          className={styles.Compare}
                          onChange={formik.handleChange}
                          name="optin"
                          value={formik.values.optin}
                          id={'optin'}
                          // disabled={checkedProducts.length >= 3 ? true : false}
                          checked={formik.values.optin}
                        />
                      </div>
                      {formik.errors?.optin && <div className={styles.formError}>{formik.errors?.optin}</div>}
                    </div>
                    <div className={`${styles.formRow} ${styles.submitRow}`}>
                      <button
                        className={`${styles.button} ${styles.buttonSubmit} ${styles.smaller} ${styles.onWhite} ${isSubmit && styles.disabled}`}
                        type="submit"
                      >
                        {isSubmit && <div className="loader"></div>}
                        {buttonLabel}
                      </button>
                      {formik.values.firstname !== '' &&
                      formik.values.lastname !== '' &&
                      formik.values.email !== '' &&
                      formik.values.postalCode !== '' ? null : (
                        <div className={styles.formError}>{generalFormErrorText}</div>
                      )}
                    </div>
                  </form>
                </div>
              </div>

              <div className={styles.hideMobile}>
                {renderMappedProductDetails()}
              </div>
            </div>
          </section>
        </Container>
      </Layout>
    </PageContext.Provider>
  );
}

export const getServerSideProps = async ({ query, locale }) => {
  const { dealer, product, isUsed } = query;

  const title = 'contact-a-dealer';

  const languageId = getLanguageId(locale);

  const { data: post } = await apiClient.get(`/api/Posts/byTitle/${title}`, { params: { languageId } });

  const data = formatPostData(post);

  let dealerInfo = null;

  if (!isEmpty(dealer)) {
    const { data: dealerData } = await crmClient.get(`/crm/dealerurl/${dealer}`);

    if (isEmpty(dealerData)) {
      return {
        notFound: true,
        redirect: {
          permanent: true,
          destination: '/404'
        }
      };
    }

    dealerInfo = dealerData[0];
  }

  let subject = '';
  let productDetails = null;

  if (!isEmpty(product)) {
    if (isUsed === 'true') {
      const { data: usedProducts } = await crmClient.get('/pmd/usedequipment');

      productDetails = usedProducts.find(({ usedID }) => usedID === parseInt(product));

      if (productDetails) {
        const { year, make, model } = productDetails;

        subject = 'USED EQUIPMENT REQUEST - ' + [year, make, model].join(' ');
      }
    } else {
      const {
        data: { product: newProduct }
      } = await apiClient.get(`/api/Products/${product}/1`, { params: { ActiveOnly: true } });

      if (newProduct) {
        productDetails = newProduct;

        subject = productDetails?.ProductText[languageId]?.Title || '';
      }
    }
  }

  data['dealerInfo'] = dealerInfo;
  data['subject'] = subject;
  data['productDetails'] = productDetails;

  return {
    props: {
      data,
      ...(await serverSideTranslations(locale, ['common', 'footer']))
    }
  };
};

const mapStateToProps = (state) => {
  return {
    code: state?.compareProduct?.code,
    // compareProducts: state?.compareProduct?.products,
    // interestedModel: state?.compareProduct?.products[0]?.Specs[0]?.SpecDisplayText,
    // interestedMake: state?.compareProduct?.products[0]?.Specs[7]?.SpecDisplayText,
    // interestedCondition: state?.compareProduct?.products[0]?.DisplayOptions[0]?.DisplayOptions[0]?.isNew,
    // productSolutionofInterest: state?.compareProduct?.products[0]?.ProductText?.Title
  };
};

export default connect(mapStateToProps, {})(ContactDealer);
